<template>
  <!-- dashboard-area start -->
  <div class="dashboard-area pt-30">
    <div class="container" style="padding: 0">
      <div class="col-lg-12" style="padding: 0">
        <div class="pannel-wrapper white-bg mb-30">
          <div class="panel-heading heading-border">
            <h4 class="pb-10">Configurar monitoramento</h4>
            <descricao :dados="dadosNCM" :loading="loading" />
          </div>
          <div class="panel-body mt-10 pt-0 pt-10">
            <!-- componente email-->
            <h5 class="mb-2">Qual e-mail você deseja receber as notificações de alterações?</h5>
            <email
              @emailSelecionado="emailAterado"
              :emails="emails"
              :loading="loadingEmail"
              :validacao="validacaoEmail"
            />
            <!-- componente filtros -->
            <!-- #################################################################################### -->
            <!-- ITENS -->
            <!-- #################################################################################### -->
            <div class="accordion basic-accourdion basic-plus" id="item1">
              <h5>Selecione os impostos que deseja que sejam enviados para seu email quando houver alteração</h5>
              <toggle
                :label="'PIS/COFINS'"
                :valor="objetoEnviar.piscofins"
                @alterado="pisCofinsAlterado()"
              />
              <toggle :label="'IPI'" :valor="objetoEnviar.ipi" @alterado="ipiAlterado()" />
              <toggle :label="'ICMS'" :valor="objetoEnviar.icms" @alterado="icmsAlterado()" />
              <toggle :label="'Isenções'" :valor="objetoEnviar.isencoes" @alterado="isencoesAlterado()" />
              <toggle :label="'Reduções'" :valor="objetoEnviar.beneficios" @alterado="beneficiosAlterado()" />
              <span
                class="erro"
                v-if="validacaoCategoria"
              >Por favor, selecione qual categoria deseja monitorar</span>
            </div>

            <div class="col-md-12" style="margin-top: 30px;">
              <button
                class="btn btn-square btn-lg btn-info btn-block"
                type="button"
                @click="monitorar()"
              >
                <b>MONITORAR</b>
                <div
                  class="spinner-border text-white loading ml-2"
                  v-if="loadingEnviar"
                  role="status"
                >
                  <span class="sr-only">Aguarde...</span>
                </div>
              </button>
            </div>
            <!-- Modal OK -->
            <b-modal
              id="modal-ok"
              ref="modal-ok"
              no-close-on-backdrop
              hide-header
              hide-footer
              centered
            >
              <div class="pannel-wrapper white-bg mb-30 text-center">
                <h3 class="cor">Monitoramento</h3>
                <p class="mt-4">
                  Agora você está monitorando a NCM escolhida.
                  Aproveite
                </p>

                <div class="pt-4">
                  <b-button
                    size="sm"
                    class="float-right botao"
                    @click="$bvModal.hide('modal-ok')"
                  >OK</b-button>
                </div>
              </div>
            </b-modal>
            <!-- Modal OK FIM -->
            <!-- Modal Limite -->
            <b-modal
              id="modal-limite"
              ref="modal-limite"
              no-close-on-backdrop
              hide-header
              hide-footer
              centered
            >
              <div class="pannel-wrapper white-bg mb-30 text-center">
                <h3 class="cor">Monitoramento</h3>
                <p class="mt-4">
                  Você atingiu o limite de 1.000 monitoramentos
                </p>

                <div class="pt-4">
                  <b-button
                    size="sm"
                    class="float-right botao"
                    @click="$router.push({ name: 'Minhas NCMs' })"
                  >OK</b-button>
                </div>
              </div>
            </b-modal>
            <!-- Modal Limite FIM -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- dashboard-area end -->
</template>

<script>
import Descricao from "../components/filtromonitoramento/Descricao";
import Email from "../components/filtromonitoramento/Email";
import toggle from "../shared/toggle";
import FiltroMonitoramento from "../models/FiltroMonitoramento";
import serviceCookie from "../services/ServiceCookie";
import serviceFiltros from "../services/ServiceFiltros";
import { setTimeout } from "timers";

export default {
  components: {
    descricao: Descricao,
    email: Email,
    toggle
  },
  data() {
    return {
      objetoEnviar: new FiltroMonitoramento(),
      emails: [],
      dadosNCM: {},
      numNCM: this.$route.params.ncm,
      loading: true,
      loadingEnviar: false,
      loadingEmail: true,
      validacaoCategoria: false,
      validacaoEmail: false
    };
  },
  async created() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      setTimeout(() => {
        if (modalId == "modal-ok") {
          this.$router.push({ name: "Minhas NCMs" });
        }
      }, 1);
    });

    this.objetoEnviar.idCliente = serviceCookie.getCookie("idCliente");
    //if (this.objetoEnviar.idCliente.length > 0)
     // this.objetoEnviar.idCliente = this.objetoEnviar.idCliente.substring(3);
    this.objetoEnviar.idCliente = parseInt(this.objetoEnviar.idCliente);

    await serviceFiltros.getEmails(this.objetoEnviar.idCliente).then(res => {
      this.emails = res;
      this.loadingEmail = false;
    });
    await serviceFiltros.getDadosNCM(this.numNCM).then(
      res => {
        if (res) {
          this.dadosNCM = res;
          this.objetoEnviar.ncm = this.dadosNCM.ncm;
          this.loading = false;
        }
      },
      err => console.error(err)
    );
  },

  beforeDestroy() {
    this.$root.$off("bv::modal::hide");
  },

  methods: {
    pisCofinsAlterado() {
      this.objetoEnviar.piscofins = !this.objetoEnviar.piscofins;
      this.objetoEnviar.validaCategoria
        ? (this.validacaoCategoria = false)
        : (this.validacaoCategoria = true);
    },
    ipiAlterado() {
      this.objetoEnviar.ipi = !this.objetoEnviar.ipi;
      this.objetoEnviar.validaCategoria
        ? (this.validacaoCategoria = false)
        : (this.validacaoCategoria = true);
    },
    icmsAlterado() {
      this.objetoEnviar.icms = !this.objetoEnviar.icms;
      this.objetoEnviar.validaCategoria
        ? (this.validacaoCategoria = false)
        : (this.validacaoCategoria = true);
    },
    isencoesAlterado() {
      this.objetoEnviar.isencoes = !this.objetoEnviar.isencoes;
      this.objetoEnviar.validaCategoria
        ? (this.validacaoCategoria = false)
        : (this.validacaoCategoria = true);
    },
    beneficiosAlterado() {
      this.objetoEnviar.beneficios = !this.objetoEnviar.beneficios;
      this.objetoEnviar.validaCategoria
        ? (this.validacaoCategoria = false)
        : (this.validacaoCategoria = true);
    },
    emailAterado(email) {
      this.objetoEnviar.email = email;
      this.objetoEnviar.email
        ? (this.validacaoEmail = false)
        : (this.validacaoEmail = true);
    },
    async monitorar() {
      this.validacaoEmail = !this.objetoEnviar.validaEmail();
      this.validacaoCategoria = !this.objetoEnviar.validaCategoria();
      let teste;
      if (
        !this.validacaoCategoria &&
        !this.validacaoEmail &&
        this.objetoEnviar.validaDados()
      ) {
        teste = true;
      } else teste = false;

      if (teste) {
        this.loadingEnviar = true;
        await serviceFiltros.comecarAMonitorar(this.objetoEnviar).then(
          res => {
            if (res == 'Você atingiu o limite de 1000 NCMs monitoradas.') {
              this.loadingEnviar = false;
              this.$refs['modal-limite'].show();
            }else{
              this.loadingEnviar = false;
              this.$refs["modal-ok"].show();
            }
          },
          err => {
            console.error(err);
            this.mensagemErro = true;
            this.loadingEnviar = false;
          }
        );
      }
    }
  }
};
</script>

<style scoped>
.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.cor {
  color: #676767;
  font-weight: bold;
}

.botao {
  background-color: #7cd1f9;
  border-color: #6ed1ff;
  color: white;
  padding: 5px 20px;
  font-weight: bold;
}

.botao:hover {
  background-color: #8ddafd;
  border-color: #6ed1ff;
  color: white;
}

.border-none {
  border: none;
}

.imagem {
  height: 70px;
}

.view {
  min-height: 83vh;
}

.erro {
  color: red;
}
</style>